import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  destroyYandexMetrica,
  hitYandexMetrica,
  initializeYandexMetrica,
} from '../../utils/yandexMetrica.js';

function isAdminPath(pathname) {
  return pathname === '/admin' || pathname.startsWith('/admin/');
}

function isRedirectPath(pathname) {
  return pathname === '/services/strelets-monitoring/';
}

function YandexMetricaTracker({ hasConsent }) {
  const location = useLocation();
  const previousUrlRef = useRef(null);
  const currentUrl = `${window.location.origin}${location.pathname}${location.search}`;

  useEffect(() => {
    if (!hasConsent || isAdminPath(location.pathname)) {
      destroyYandexMetrica();
      previousUrlRef.current = null;
      return undefined;
    }

    if (isRedirectPath(location.pathname)) {
      return undefined;
    }

    let cancelled = false;
    const referer = previousUrlRef.current || document.referrer || undefined;

    initializeYandexMetrica()
      .then((isInitialized) => {
        if (cancelled || !isInitialized) {
          return;
        }

        hitYandexMetrica(currentUrl, {
          title: document.title,
          referer,
        });
        previousUrlRef.current = currentUrl;
      })
      .catch(() => {
        // Analytics failures must not affect the website.
      });

    return () => {
      cancelled = true;
    };
  }, [currentUrl, hasConsent, location.pathname]);

  return null;
}

export default YandexMetricaTracker;
